<template>
  <div class="home">
		<div class="home_background parallax-window" data-parallax="scroll" data-image-src="../assets/img/about.jpg" data-speed="0.8"></div>
		<div class="home_container">
			<div class="container">
				<div class="row">
					<div class="col">
						<div class="home_content">
							<div class="home_title">About <span>US</span></div>
							<div class="breadcrumbs">
								<ul>
									<li><router-link to="/">Home</router-link></li>
									<li>About Securedcares</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- About -->

	<div class="about">
		<div class="container">
			<div class="row">
				<div class="col-lg-8">
					<div class="section_title">
            <h2>
              All our caregivers pass extensive background and reference checks. We ensure they have the necessary qualifications and training for their roles. Many also hold additional certifications in first aid, dementia care, or palliative care.
            </h2>
          </div>
					<div class="about_text">
						<p>
              Welcome to Secured Home Care, where your health and well-being are our top priorities. 
              We specialize in providing exceptional pediatric care to meet the unique needs of infants, 
              children, and adolescents. Our team of experienced pediatricians and healthcare professionals 
              is dedicated to delivering comprehensive medical services in a safe, nurturing, and family-centered 
              environment.
            </p>
						<p>
              At Secured Home Care, we believe that everyone deserves the best in life. From routine check-ups and 
              vaccinations to the management of acute and chronic conditions, we offer a full spectrum of pediatric 
              care designed to support your child's growth and development. Our commitment to excellence ensures 
              that your child receives personalized attention and the highest standard of medical care.
            </p>
						<p>
              We are dedicated to providing compassionate and professional caregiving services to individuals and families. 
              With a deep commitment to enhancing the quality of life for our clients, we offer personalized care solutions 
              that prioritize dignity, respect, and independence.
            </p>
						<p>
              Choose Secured Home Care for compassionate, reliable, and expert pediatric care that you can trust. Your health is 
              our mission and we are here to support your family every step of the way.
						</p>
            <div class="button about_button">
              <router-link to="/contact">Find a caregiver</router-link>
            </div>
					</div>

					<div class="row loaders_container">
						<div class="col-md-3 loader_col">
							<!-- Loader -->
							<div class="loader" data-perc="0.90"><span>Hard Work</span></div>
						</div>
						<div class="col-md-3 loader_col">
							<!-- Loader -->
							<div class="loader" data-perc="0.95"><span>Passion</span></div>
						</div>
						<div class="col-md-3 loader_col">
							<!-- Loader -->
							<div class="loader" data-perc="0.90"><span>Hard Work</span></div>
						</div>
						<div class="col-md-3 loader_col">
							<!-- Loader -->
							<div class="loader" data-perc="0.95"><span>Passion</span></div>
						</div>
					</div>
				</div>

				<!-- Boxes -->
				<div class="col-lg-4 boxes_col">
          <div class="box box_appointments">
            <router-link to="/contact">
              <div class="box_icon d-flex flex-column align-items-start justify-content-center">
                <div style="width: 29px; height:29px;">
                  <img src="../assets/img/phone-call.svg" alt="">
                </div>
              </div>
              <div class="box_title">Find a caregiver </div>
              <div class="box_text">
                Searching for the right caregiver has never been easier. To find a qualified and compassionate caregiver in your area. 
                Contact us today. Click here
              </div>
            </router-link>
          </div>
          <div class="box box_appointments">
            <router-link to="/contact">
              <div class="box_icon d-flex flex-column align-items-start justify-content-center">
                <div style="width: 29px; height:29px;">
                  <img src="../assets/img/phone-call.svg" alt="">
                </div>
              </div>
              <div class="box_title">Become a care provider</div>
              <div class="box_text">
                Join our team of dedicated professionals and make a meaningful difference in people's lives. 
                As a caregiver with us, you'll receive comprehensive training, ongoing support, and the opportunity to grow in a rewarding career.
              </div>
            </router-link>
          </div>
				</div>
			</div>
		</div>
	</div>
</template>
<style scoped>
@import url("../assets/css/about.css");
@import url("../assets/css/about_responsive.css");
.home_background {
    position:absolute;
    top:0;
    left:0;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
}

.home_background::before {
    content: "";
    position: absolute;
    inset: 0;
    background: url("../assets/img/about.jpg") center/cover no-repeat;
    will-change: transform;
    z-index: -1;
}
</style>